<div class="wrap parametre_component">
  <h3>Mes préférences d'affichage</h3>

  <div class="btn_action">
    <button type="button" (click)="gotoShowBtnParamFluxActu()">Gérer toutes mes actus</button>
    <button type="button" (click)="gotoShowBtnParamMenu()">Modifier mes menus</button>
  </div>

</div>